const partners = [
  {
    id: 1,
    name: "Palang Merah Indonesia",
    image: "pmi.png",
  },
  {
    id: 2,
    name: "MTSN 1 Blitar",
    image: "mtsn1-blitar.png",
  },
  {
    id: 3,
    name: "MI Miftahun Najah",
    image: "mi-miftahun-najah.png",
  },
  {
    id: 4,
    name: "Rumah Kinasih",
    image: "rumah_kinasih.png",
  },
  {
    id: 5,
    name: "Herbalova",
    image: "herbalova.png",
  },
  {
    id: 6,
    name: "Yayasan Rukun Ginawa Sentosa",
    image: "yargis.png",
  },
  {
    id: 7,
    name: "Buku Buka",
    image: "bukubuka.png",
  },
  {
    id: 8,
    name: "Dapur Mardjono",
    image: "dapurmardjono.png",
  },
  {
    id: 9,
    name: "Griya Sakinah",
    image: "griyasakinah.png",
  },
];

export default partners;
